<template>
  <sui-modal class="wrapper" v-model="visible" :closable="false" :style="{zIndex}">
    <sui-modal-header class="header">
      Create service
    </sui-modal-header>
    <sui-modal-content scrolling>
      <div class="roles" v-show="!entity">
        <div class="role" v-for="(types, groupTitle) in typesByGroup" :key="groupTitle">
          <h4 class="ui header">{{groupTitle}} services</h4>
          <sui-card-group class="types" :class="{doubling: types.length > 5}" :itemsPerRow="types.length">
            <sui-card class="type" :class="{link: !type.soon}" v-for="type in types" :key="type.typeName" @click="selectType(type)">
              <div class="type-logo">
                <Logo class="logo" :serviceType="type.typeName" />
              </div>
              <div class="type-title">
                {{type.typeTitle}}
              </div>
              <sui-dimmer inverted :active="type.soon">
                <i class="lock icon" />
                not available
              </sui-dimmer>
            </sui-card>
          </sui-card-group>
        </div>
      </div>
      <sui-form :error="hasApiErrors" :loading="loading" @submit.prevent="submit()" v-if="entity">
        <FormService v-model="entity" mode="creating" />
        <sui-message error>
          {{apiErrors}}
        </sui-message>
      </sui-form>
    </sui-modal-content>
    <sui-modal-actions>
      <sui-button class="back" icon="arrow circle left" label-position="left" v-if="entity" @click="reset()">
        Back
      </sui-button>
      <div class="ui buttons">
        <sui-button icon="check" label-position="left" color="green" :disabled="loading || hasEntityErrors" @click="submit()" data-goal="CREATE_SERVICE_TRY">Confirm</sui-button>
        <sui-button icon="ban" label-position="right" color="red" @click="cancel()">Cancel</sui-button>
      </div>
    </sui-modal-actions>
    <sui-dimmer class="dimmer" :active="success" inverted>
      <h2 class="ui icon header">
        <i class="green check circle icon" />
        Deploying started
      </h2>
    </sui-dimmer>
  </sui-modal>
</template>

<script>
  import {mapGetters} from 'vuex'
  import groupBy from 'lodash/groupBy'
  import objects from '@/objects'
  import utils from '@/utils'
  import FormService from '@/components/forms/Service'
  import ModalForm from '@/mixins/ModalForm'

  export default {
    name: 'ModalCreateService',
    mixins: [
      ModalForm,
    ],
    components: {
      FormService,
    },
    computed: {
      ...mapGetters(['projects']),
      project() {
        const name = this.$route.params.project
        const project = this.projects.find(entity => entity.id === name || entity.name === name)
        return project
      },
      typesByGroup() {
        const activeServices = objects._services.filter(object => object.active)
        const sortedServices = activeServices.sort((object1, object2) => object1.order - object2.order)
        return groupBy(sortedServices, 'roleTitle')
      },
    },
    methods: {
      open(entityParams) {
        this.visible = true
        if (entityParams) {
          this.showForm(entityParams)
        }
      },
      selectType(type) {
        utils.reachGoal(`CREATE_SERVICE_SELECT_${type.typeName.toUpperCase()}`)
        if (type && !type.soon) {
          this.showForm({type: type.typeName})
        }
      },
      showForm(entity = {}) {
        this.entity = {
          ...entity,
          name: entity.name || utils.generateName(),
          project: entity.project || (this.project && this.project.id) || '',
        }
      },
      onSuccess() {
        this.close()
        utils.reachGoal('CREATE_SERVICE_SUCCESS')
      },
      onFail() {
        utils.reachGoal('CREATE_SERVICE_FAIL')
      },
    },
    created() {
      this.$modals.createService = this
    },
  }

</script>

<style scoped>
  .roles { display: flex; flex-wrap: wrap; justify-content: space-between; }
  .role:nth-child(1), .role:nth-child(2) { margin-bottom: 3em; width: 100%;  }
  .role:nth-child(3) { width: 55%;  }
  .role:nth-child(4) { width: 35%;  }
  .types { align-items: stretch; }
  .type { text-align: center; }
  .type-logo { display: flex; justify-content: center; background-color: #eee; }
  .type-title { padding: .5em 0; font-size: 1.1em; font-weight: bold; }
  .logo { margin: .5em; }
  .back { float: left; text-align: left; }
</style>
